import { usePageDrawer } from '@app/components/page/drawer/PageDrawerContext';
import { Box } from '@mui/material';
import { useEffect } from 'react';
import { defineMessage, useIntl } from 'react-intl';
import { useStreamSettingsStore } from '../../../../stores/stream-screen-settings.store';
import { LiveTopicsDetailView } from '../detail-view/LiveTopicsDetailView';
import { LiveTopicsPanelHeader } from '../header/LiveTopicsPanelHeader';

const panelTitleMessage = defineMessage({
  id: 'logger.streamScreen.liveTopics.panel.title',
  defaultMessage: 'Live Topics',
});

/**
 * Standalone drawer panel that shows a single topic's detail.
 * Topic is read from stream settings store (drawerData.topic); cleared on unmount.
 * Reuses LiveTopicsDetailView with a single topic (no prev/next).
 * Uses the same header as LiveTopicsPanel (icon + "Live Topics" + close).
 */
export function TopicDetailPanel() {
  const { $t } = useIntl();
  const { closeDrawer } = usePageDrawer();
  const drawerData = useStreamSettingsStore((s) => s.drawerData);
  const updateSettings = useStreamSettingsStore((s) => s.updateSettings);
  const topic = drawerData?.topic ?? null;

  useEffect(() => {
    return () => {
      updateSettings({ drawerData: null });
    };
  }, [updateSettings]);

  const header = (
    <LiveTopicsPanelHeader
      title={$t(panelTitleMessage)}
      isDetailView={false}
      onBack={() => {}}
      onClose={closeDrawer}
    />
  );

  if (topic == null) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      {header}
      <LiveTopicsDetailView topic={topic} topics={[topic]} onSelectTopic={() => {}} />
    </Box>
  );
}
